import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { StatBand } from "@/components/landing/StatBand";
import { PainGrid } from "@/components/landing/PainGrid";
import { Ladder } from "@/components/landing/Ladder";
import { Solution } from "@/components/landing/Solution";
import { SearchSection } from "@/components/landing/SearchSection";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Categories } from "@/components/landing/Categories";
import { Fairness } from "@/components/landing/Fairness";
import { ReviewForm } from "@/components/landing/ReviewForm";
import { Signup } from "@/components/landing/Signup";
import { Footer } from "@/components/landing/Footer";
import AdminPage from "@/pages/AdminPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ReviewerProfilePage from "@/pages/ReviewerProfilePage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";

export const scrollToJoin = () => {
  if (window.__lenis) {
    window.__lenis.scrollTo("#join", { offset: -72 });
  } else {
    document.getElementById("join")?.scrollIntoView({ behavior: "smooth" });
  }
};

const Landing = () => (
  <div className="min-h-screen bg-paper text-ink font-body">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <StatBand />
      <PainGrid />
      <Ladder />
      <Solution />
      <SearchSection />
      <HowItWorks />
      <Categories />
      <Fairness />
      <ReviewForm />
      <Signup />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.1 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/reviewer/:id" element={<ReviewerProfilePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
